import React from 'react';

import { TileCarouselResult } from 'api/types/shared.types';
import ArrowNavigation from 'components/ArrowNavigation';
import { Box } from 'components/Box';
import { DotNavigationButton } from 'components/Button';
import Flex from 'components/Flex';
import { RouterLink as Link } from 'components/Link';
import Carousel, { Slide } from 'containers/Carousel';
import { isEmpty, range } from 'utils/functional';

import { Section } from './Section';
import { TileCarouselHeader } from './TileCarouselHeader';

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line react/function-component-definition
export const TileCarousel = ({
  headline,
  results,
  seeAllText,
  seeAllUrl,
  listingType,
  carouselLocation,
  fromListingId,
  layout = 'REGULAR',
  source,
  additionalAnalyticsProps,
}: {
  headline: string | null | undefined;
  results: Array<TileCarouselResult> | null | undefined;
  seeAllText?: string;
  seeAllUrl?: string;
  listingType: string;
  carouselLocation?: string;
  fromListingId?: string;
  layout?: 'SLIM' | 'REGULAR';
  source?: string;
  additionalAnalyticsProps?: Record<string, string>;
}) => (
  <>
    <Box>
      <TileCarouselHeader
        layout={layout}
        headline={headline}
        linkNode={
          seeAllText &&
          seeAllUrl && (
            <Link data-qa-id="tile-carousel-see-all" to={seeAllUrl}>
              {seeAllText}
            </Link>
          )
        }
      />
    </Box>

    <Box>
      <Box
        maxWidth={[250, null, 718, 'none']}
        mx={['auto', null, null, -24]}
        width="auto"
        px={[12, null, null, 20]}
      >
        <Carousel
          data-qa-id="tile-carousel"
          pageLength={layout === 'SLIM' ? [1, 1, 2, 3, 3] : [1, 1, 3, 4, 4]}
          navigation={[
            // TODO: Fix this the next time the file is edited.
            // eslint-disable-next-line react/no-unstable-nested-components
            ({
              current,
              total,
              goToPage,
              prevPage,
              nextPage,
            }: {
              // TODO: Fix this the next time the file is edited.
              // eslint-disable-next-line react/no-unused-prop-types
              current: number;
              // TODO: Fix this the next time the file is edited.
              // eslint-disable-next-line react/no-unused-prop-types
              total: number;
              // TODO: Fix this the next time the file is edited.
              // eslint-disable-next-line react/no-unused-prop-types, @typescript-eslint/no-explicit-any
              goToPage: (...args: Array<any>) => any;
              // TODO: Fix this the next time the file is edited.
              // eslint-disable-next-line react/no-unused-prop-types, @typescript-eslint/no-explicit-any
              prevPage: (...args: Array<any>) => any;
              // TODO: Fix this the next time the file is edited.
              // eslint-disable-next-line react/no-unused-prop-types, @typescript-eslint/no-explicit-any
              nextPage: (...args: Array<any>) => any;
            }) => (
              <nav>
                {/* TODO: Fix this the next time the file is edited. */}
                {/* eslint-disable-next-line react/jsx-no-useless-fragment */}
                <>
                  <ArrowNavigation
                    nextPage={nextPage}
                    prevPage={prevPage}
                    current={current}
                    total={total}
                    outset
                  />
                  {total > 1 && (
                    <Box position="relative" height={32}>
                      <Flex
                        position="absolute"
                        bottom={0}
                        left="50%"
                        transform="translateX(-50%)"
                        justifyContent="center"
                        maxWidth="calc(100vw - 16px)"
                      >
                        {range(total).map((index) => (
                          <DotNavigationButton
                            key={index}
                            goToPage={goToPage}
                            index={index}
                            isActive={index === current}
                          />
                        ))}
                      </Flex>
                    </Box>
                  )}
                </>
              </nav>
            ),
          ]}
          slides={() =>
            !isEmpty(results) && Array.isArray(results)
              ? results.map((result, index) => (
                  <Slide // eslint-disable-next-line react/no-array-index-key
                    key={`${'section'}-${index}`}
                    data-qa-id="tile-carousel-slide"
                    data-qa-listing-id={result.objectID}
                  >
                    <Section
                      result={result}
                      listingType={listingType}
                      carouselLocation={carouselLocation}
                      headline={headline}
                      fromListingId={fromListingId}
                      results={results}
                      layout={layout}
                      source={source}
                      additionalAnalyticsProps={additionalAnalyticsProps}
                    />
                  </Slide>
                ))
              : range(4).map((index) => (
                  <Slide key={`${'section'}-${index}`}>
                    <Box />
                  </Slide>
                ))
          }
        />
      </Box>
    </Box>
  </>
);
